// extracted by mini-css-extract-plugin
module.exports = {"pair":"PeriodOfExecution_pair__3iTuC","centered":"PeriodOfExecution_centered__1NB_t","vertical":"PeriodOfExecution_vertical__1YqX2"};